import { render, staticRenderFns } from "./PayServiceDetailFooter.vue?vue&type=template&id=3cf9a0af&"
import script from "./PayServiceDetailFooter.vue?vue&type=script&lang=ts&"
export * from "./PayServiceDetailFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports